import { render, staticRenderFns } from "./RegistroArma.vue?vue&type=template&id=e76e7b72&scoped=true"
import script from "./RegistroArma.vue?vue&type=script&lang=js"
export * from "./RegistroArma.vue?vue&type=script&lang=js"
import style0 from "./RegistroArma.vue?vue&type=style&index=0&id=e76e7b72&prod&lang=css"
import style1 from "./RegistroArma.vue?vue&type=style&index=1&id=e76e7b72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e76e7b72",
  null
  
)

export default component.exports